<template>
    <div id="miniStepper">
        <div class="container">
            <div
                @click="itemlickHandler(index)"
                v-for="(page, index) in count"
                :class="activeIndex >= index ? 'item active' : 'item'"
            >
                {{ index + 1 }}
                <div v-if="index !== 0" class="stick"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "MiniStepper",
    props: ["count", "activeIndex"],
    data() {
        return {
            showIndex: this.activeIndex,
        };
    },
    methods: {
        itemlickHandler(index) {
            this.$emit("changeStep", index);
        },
    },
    watch: {
        activeIndex() {
            this.showIndex = this.activeIndex;
        },
    },
};
</script>

<style scoped>
#miniStepper {
    .container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 300px;

        .item {
            position: relative;
            background-color: #b4b4b4;
            color: white;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 5px;
            border-radius: 50%;
            width: 40px;
            height: 40px;
            cursor: pointer;
            user-select: none;

            .stick {
                position: absolute;
                background-color: #b4b4b4;
                width: 90px;
                height: 3px;
                right: 26px;
            }

            &.active {
                background-color: #f3643b;

                .stick {
                    background-color: #f3643b;
                }
            }
        }
    }
}
</style>
